export default __webpack_public_path__ + "static/media/798.241087fd.png";